import { render, staticRenderFns } from "./FormatFilter.vue?vue&type=template&id=aab080d6&scoped=true&"
import script from "./FormatFilter.vue?vue&type=script&lang=ts&"
export * from "./FormatFilter.vue?vue&type=script&lang=ts&"
import style0 from "./FormatFilter.vue?vue&type=style&index=0&id=aab080d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab080d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCheckbox,VContainer,VIcon,VList,VMenu,VRow})
